import "./TheGrid.module.css";
import NexusHeader from "@/reusable_sections/Header";
import TournamentSchedule from "./sections/TournamentSchedule";
import CommunityStats from "./sections/CommunityStats";
import TacticalSupport from "./sections/TacticalSupport";
import NexusFooter from "@/reusable_sections/Footer";
export default function TheGridPage() {
  return <div>
      <NexusHeader />
      <TournamentSchedule />
      <CommunityStats />
      <TacticalSupport />
      <NexusFooter />
    </div>;
}